<hr class="separator" />
<div class="row value">
  <div class="col-sm-6">
    <ng-content select="[column]"></ng-content>
  </div>
  <div class="col-sm-3 col-sm-offset-3">
    <ng-content select="[button]"></ng-content>
  </div>
</div>
